module.exports = __webpack_public_path__ + "img/2.b686619c.jpg";